import Logo from "../../../images/logo.png"
import LogoDark from "../../../images/logo-dark.png"
import {Link, useLocation} from "react-router-dom";
import TopbarButton from "./TopbarButton";
import TopbarLoginWidget from "./TopbarLoginWidget";
import TopbarMenuItem from "./TopbarMenuItem";
import {sitemap} from "../Sitemap";
import classNames from "classnames";
import TopbarUserInfoWidget from "./TopbarUserInfoWidget";
import {useSelector} from "react-redux";

const Topbar = () => {
    const location = useLocation();
    const { isAuthenticated } = useSelector((state) => state.auth);
    const pathname = location.pathname;
    const match = pathname === '/' || pathname === '/download' || pathname === '/marketplace';
    const headerClassNames = {
        'header': true,
        'header-fixed-on-mobile': true,
        'header-transparent': match,
        'header-absolute': match,
        'header-relative': !match,
        'nav-dark': !match
    }

    return (
        <header className={classNames(headerClassNames)}
                data-helper-in-threshold="200" data-helper-out-threshold="500" data-sticky-threshold="200"
                data-bkg-threshold="100" data-compact-threshold="100">
            <div className="header-inner">
                <div className="row nav-bar">
                    <div className="column width-12 nav-bar-inner">
                        <div className="logo">
                            <div className="logo-inner">
                                <Link to="/"><img src={LogoDark} alt="흑우촌 로고"/></Link>
                                <Link to="/"><img src={Logo} alt="흑우촌 로고"/></Link>
                            </div>
                        </div>
                        <nav className="navigation nav-block secondary-navigation nav-right">
                            <ul>
                                {
                                    !isAuthenticated && <TopbarLoginWidget />
                                }
                                {
                                    isAuthenticated && <TopbarUserInfoWidget />
                                }
                                <TopbarButton />
                            </ul>
                        </nav>
                        <nav className="navigation nav-block primary-navigation nav-center">
                            <ul>
                                {sitemap.filter(item => item.navigation).map(firstDepthMenu => (
                                    <TopbarMenuItem key={firstDepthMenu.path} name={firstDepthMenu.name} to={firstDepthMenu.path}>
                                        {firstDepthMenu.children &&
                                            <ul className="sub-menu">
                                                {
                                                    firstDepthMenu.children.filter(item => item.navigation).map(secondDepthMenu => (
                                                        <TopbarMenuItem key={secondDepthMenu.path} name={secondDepthMenu.name} to={firstDepthMenu.path + '/' + secondDepthMenu.path} />
                                                    ))
                                                }
                                            </ul>
                                        }
                                    </TopbarMenuItem>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Topbar;